import MovimientosTipoForm from "./MovimientosTipoForm";
export default MovimientosTipoForm;